import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";
import { TipDialogComponent } from './tip-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [ TipDialogComponent ],
  exports: [ TipDialogComponent ],
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    MatDialogModule
  ]
})
export class TipDialogModule { }
